export default __webpack_public_path__ + "static/media/beans2.4a9f9454.svg";